@if (flow.isOpen) {
  <app-confirm-action-modal
    title="Remove member"
    confirmLabel="Remove"
    busyLabel="Removing..."
    cancelButtonClass="btn-outlined"
    [busy]="flow.busy"
    [confirmDisabled]="!flow.canConfirm"
    [closeOnOverlayClick]="false"
    [mobileSheet]="false"
    testId="family-remove-modal"
    (confirm)="flow.confirm()"
    (cancel)="flow.close()"
  >
    <div class="remove">
      <p class="remove__text" data-testid="remove-text">
        Take <strong>{{ plate }}</strong> out of the family plan? Its membership continues at the
        regular price from the next renewal.
      </p>
      @if (isPrimary) {
        <p class="remove__text">
          This plate is the primary.
          @if (flow.needsPick) {
            Pick who becomes the primary.
          } @else {
            The other plate becomes the primary and the family plan ends.
          }
        </p>
      }
      @if (flow.needsPick) {
        <div class="form-group">
          <label for="remove-new-primary">New primary</label>
          <mat-select
            id="remove-new-primary"
            class="form-select"
            panelClass="family-discount-panel"
            disableOptionCentering
            data-testid="remove-new-primary"
            [(ngModel)]="flow.newPrimaryId"
            [disabled]="flow.busy"
          >
            @for (item of flow.candidates; track item.value) {
              <mat-option [value]="item.value">{{ item.label }}</mat-option>
            }
          </mat-select>
        </div>
      }
      @if (flow.error) {
        <p class="remove__error" role="alert" data-testid="remove-error">{{ flow.error }}</p>
      }
    </div>
  </app-confirm-action-modal>
}
